import React from 'react';
import cn from 'classnames';
import { commonPublicPropTypes } from 'shared/proptypes/ContentModule';
import { CONTENT_MODULE_TYPE, CONTENT_MODULE_TYPES } from 'shared/constants';
import TextView from './Text';
import PeopleView from './People';
import GalleryView from './Gallery';
import HtmlView from './Html';
import styles from './View.module.scss';

const viewComponents = {
  [CONTENT_MODULE_TYPE.TEXT]: TextView,
  [CONTENT_MODULE_TYPE.PEOPLE]: PeopleView,
  [CONTENT_MODULE_TYPE.GALLERY]: GalleryView,
  [CONTENT_MODULE_TYPE.HTML]: HtmlView,
};

const ContentModuleView = ({ type, content }) => {
  if (!CONTENT_MODULE_TYPES.includes(type)) {
    return <div>unknown module type</div>;
  }

  const Component = viewComponents[type];
  return (
    <div className={cn(styles.module, { [styles.halfMargin]: type === CONTENT_MODULE_TYPE.PEOPLE })}>
      <Component {...content} />
    </div>
  );
};

ContentModuleView.propTypes = commonPublicPropTypes;

export default ContentModuleView;
